const tabsItemActiveClasses =
  "tab__item--active bg-secondary-dark-700 text-white rounded-full";
const tabsItemInActiveClasses = "tab__item--inactive text-secondary-dark-700";

function isMobile() {
  const matches = window.matchMedia("screen and (max-width: 767px)").matches;
  return matches;
}

function debounce(fn, delay) {
  let timer;
  return (...args) => {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      fn(...args);
    }, delay);
  };
}

export const tabs = () => ({
  activeTabId: null,
  activeTabMobile: [],
  init() {
    const initialActiveTabId = this.$el.getAttribute("active-tab-id");
    if (initialActiveTabId) {
      this.activeTabId = initialActiveTabId;
    }
    this.bindEvents();
  },
  tabItem(tabId) {
    return {
      ["x-bind:class"]() {
        return this.activeTabId == tabId
          ? tabsItemActiveClasses
          : tabsItemInActiveClasses;
      },
      ["@click"]() {
        this.activeTabId = tabId;

        const currentScrollPosition =
          document.documentElement.scrollTop || document.body.scrollTop;
        const tabsElement = this.$refs.tabs;
        const tabsElementOffset = tabsElement.offsetTop;

        if (currentScrollPosition > tabsElementOffset) {
          document.documentElement.scrollTop = document.body.scrollTop =
            tabsElementOffset - 120;
        }
      },
    };
  },
  tabContent(tabId) {
    return {
      ["x-show"]() {
        return this.isMobile
          ? this.activeTabMobile.indexOf(tabId) > -1
          : this.activeTabId == tabId;
      },
    };
  },
  tabsContentSearch(tabId) {
    return {
      ["x-show"]() {
        return this.activeTabId == tabId;
      },
    };
  },
  tabItemMobile(tabId) {
    return {
      ["x-bind:class"]() {
        return this.activeTabMobile.indexOf(tabId) > -1
          ? tabsItemActiveClasses
          : tabsItemInActiveClasses;
      },
      ["@click"]() {
        const currentIndex = this.activeTabMobile.indexOf(tabId);
        if (currentIndex == -1) {
          return (this.activeTabMobile = [...this.activeTabMobile, tabId]);
        }
        this.activeTabMobile.splice(currentIndex, 1);
      },
    };
  },
  bindEvents() {
    this.isMobile = isMobile();
    window.addEventListener(
      "resize",
      debounce(() => {
        this.isMobile = isMobile();
        console.log("exdcuted in debounce", this.isMobile);
      }, 300)
    );
  },
});
